export default "https://cdn-static.gokick.com/assets/9175df2ab050434674d4a27e4dae3ab0ebb22d80/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";